var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon, XIcon, } from '../icons/index.js';
export const Alert = props => {
    const { as, status, title, children, withClose = false, className } = props, rest = __rest(props, ["as", "status", "title", "children", "withClose", "className"]);
    let icon;
    switch (status) {
        case 'error':
            icon = (React.createElement(XCircleIcon, { className: "h-5 w-5 text-danger-400", "aria-hidden": "true" }));
            break;
        case 'warning':
            icon = (React.createElement(ExclamationIcon, { className: "h-5 w-5 text-warning-400", "aria-hidden": "true" }));
            break;
        case 'success':
            icon = (React.createElement(CheckCircleIcon, { className: "h-5 w-5 text-success-400", "aria-hidden": "true" }));
            break;
        case 'info':
            icon = (React.createElement(InformationCircleIcon, { className: "h-5 w-5 text-info-400", "aria-hidden": "true" }));
            break;
        default:
            break;
    }
    const Component = as || 'div';
    return (React.createElement(Component, Object.assign({ className: clsx('relative rounded-md p-4', [
            status === 'error' && 'bg-danger-50',
            status === 'warning' && ' bg-warning-50',
            status === 'success' && 'bg-success-50',
            status === 'info' && 'bg-info-50 ',
        ], className) }, rest),
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "flex-shrink-0" }, icon),
            React.createElement("div", { className: "ml-3" },
                title && (React.createElement("h3", { className: clsx('text-sm font-medium ', [
                        status === 'error' && 'text-danger-800',
                        status === 'warning' && 'text-warning-800',
                        status === 'success' && 'text-success-800',
                        status === 'info' && 'text-info-800',
                    ]) }, title)),
                children && (React.createElement("div", { className: clsx('text-sm', !!title && 'mt-2 ', [
                        status === 'error' && 'text-danger-700',
                        status === 'warning' && 'text-warning-700',
                        status === 'success' && 'text-success-700',
                        status === 'info' && 'text-info-700',
                    ]) }, children)),
                withClose && (React.createElement("span", { className: "absolute top-0 right-0 flex items-center mr-2 mt-2" },
                    React.createElement("button", { type: "button", className: clsx('inline-flex rounded-md p-1.5', [
                            status === 'error' && 'bg-danger-50',
                            status === 'warning' && ' bg-warning-50',
                            status === 'success' && 'bg-success-50',
                            status === 'info' && 'bg-info-50 ',
                        ]) },
                        React.createElement("span", { className: "sr-only" }, "Dismiss"),
                        React.createElement(XIcon, { className: clsx('h-4 w-4', [
                                status === 'error' && 'text-danger-700',
                                status === 'warning' && 'text-warning-700',
                                status === 'success' && 'text-success-700',
                                status === 'info' && 'text-info-700',
                            ]), "aria-hidden": "true" }))))))));
};
//# sourceMappingURL=Alert.js.map